import { Component, DetailEvent, Entity, registerComponent } from "aframe";
import { AnchorEntity } from "../anchor";
import { SlotEntity } from "../slot";
import { TemplateEvent } from "../template";




interface OfflineEntityComponent extends Component
{
	data : {
		template : string;
		container? : Entity;
		slot? : string;
		anchor? : string;
	};
	ready : Promise<void>;
	locationPending? : string;
}

registerComponent("offline-entity", {
	schema : { 
		template : { type : "string" },
		container : { type : "selector" },
		slot : { type : "string" },
		anchor : { type : "string" } 
	},
	init(this : OfflineEntityComponent)
	{
		const template = this.data.template, container = this.data.container, slotName = this.data.slot, anchorName = this.data.anchor;

		if(template && container && slotName) //Until template loaded and slot found, if any.
			this.locationPending = "Slot " + slotName + " of " + (container.id || container.className || container.tagName);

		this.el.addEventListener("despawn-entity", () => this.el.remove() );
		
		this.el.addEventListener("rotate-entity", (event) =>
		{
			const angle = (event as DetailEvent<number>).detail;
			this.el.object3D.rotateY(angle * Math.PI / 180.0);
		});

		this.ready = new Promise( (resolve, reject) =>
		{
			
			if(!template)
				return resolve();

			/* const captureEvent = async (event : Event) =>
			{
				event.preventDefault();
				event.stopPropagation();

				await this.ready;

				event.target?.dispatchEvent( new CustomEvent(event.type, { detail : (event as CustomEvent).detail, bubbles : true } ) );
			}; */

			const templateLoadedListener = (async (event : Event) =>
			{
				const template = (event as TemplateEvent).detail.component;
				if(template.attrName != "template__offline-entity") return;
	
				if(container)
				{
					let slotEl : SlotEntity | undefined = undefined;
					for(let slot of Array.from(container.querySelectorAll<SlotEntity>("[slot]")))
					{
						const data = slot.components.slot.data;
						if(data && ((data.name || data.type) == slotName))
						{
							slotEl = slot;
							break;
						}
					}


					const delayed = !slotEl;

					if( delayed )
					{
						this.el.object3D.visible = false;
						if(this.el.components["ammo-body"])
							this.el.setAttribute("ammo-body", { enabled : false });

						slotEl = await new Promise<SlotEntity>( (resolve, reject) =>
						{
							const listener = (event : DetailEvent<string>) =>
							{
								if(event.detail != slotName) return;
								container.removeEventListener("slot-initialized", listener as EventListener);
								resolve(event.target as SlotEntity);
							};
							container.addEventListener("slot-initialized", listener as EventListener);
						});
					}
					
					
					let anchorEl : AnchorEntity | undefined = undefined;
					const anchors = Array.from(this.el.querySelectorAll<AnchorEntity>("[anchor]"));
					if(this.el.components.anchor)
						anchors.unshift(this.el as AnchorEntity);
					for(let anchor of anchors)
					{
						const aComp = anchor.components.anchor;
						if(slotEl && !aComp.fits(slotEl)) continue;
						if(anchorName && (anchorName != aComp.data.name)) continue;
						anchorEl = anchor;
						break;
					}

					if(slotEl && anchorEl)
					{
						if(delayed)
						{
							this.el.object3D.visible = true;
							if(this.el.components["ammo-body"])
								this.el.setAttribute("ammo-body", { enabled : true });
						}

						slotEl.setAttribute("slot", { item : this.el, anchor : anchorEl });

						//OK, now initial location is known
						delete this.locationPending;
						this.el.emit('location-initialized', this, false);
					}
					else
						console.warn("Could not attach",anchorName,"to", slotName)
				}
	
				this.el.removeEventListener("template-loaded", templateLoadedListener);
				//this.el.removeEventListener("gateway-initialized", captureEvent, { capture : true } );


				resolve();
			});

			//this.el.addEventListener("gateway-initialized", captureEvent, { capture : true } );
			this.el.addEventListener("template-loaded", templateLoadedListener);
			this.el.setAttribute("template__offline-entity", this.data.template );
		} );
	}
});